import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { RadioButton } from 'react-native-paper';
import { theme } from '../theme';
export const WeekStartsOnControl = ({ value, onChange, disabled = false, isSaving = false, compact = false }) => {
    const selected = value === 0 || value === 1 ? String(value) : '';
    const labelStyle = compact ? styles.labelOnPurple : styles.label;
    const radioLabelStyle = compact
        ? styles.radioLabelOnPurple
        : styles.radioLabel;
    const radioColor = compact
        ? theme.colors.surfaceElevated
        : theme.colors.primary;
    return (<View style={compact ? styles.compactBlock : styles.block}>
      <Text style={labelStyle}>Week starts on</Text>
      {!compact && (<Text style={styles.hint}>
          Sets Meal Map columns and which days are loss / maintenance / reward.
          Change anytime if the client’s schedule shifts.
        </Text>)}
      <RadioButton.Group onValueChange={next => {
            if (!disabled && !isSaving) {
                onChange(Number(next));
            }
        }} value={selected}>
        <View style={[
            styles.radioRow,
            disabled || isSaving
                ? styles.pointerEventsNone
                : styles.pointerEventsAuto,
        ]}>
          <View style={styles.radioItem}>
            <RadioButton value="1" color={radioColor} uncheckedColor={radioColor}/>
            <Text style={radioLabelStyle}>Monday</Text>
          </View>
          <View style={styles.radioItem}>
            <RadioButton value="0" color={radioColor} uncheckedColor={radioColor}/>
            <Text style={radioLabelStyle}>Sunday</Text>
          </View>
          {isSaving ? (<ActivityIndicator style={styles.spinner} color={compact ? theme.colors.surfaceElevated : undefined}/>) : null}
        </View>
      </RadioButton.Group>
    </View>);
};
const styles = StyleSheet.create({
    block: {
        marginTop: 16,
    },
    compactBlock: {
        marginTop: 8,
    },
    label: {
        fontWeight: '600',
        fontSize: 15,
        color: theme.colors.textPrimary,
        marginBottom: 4,
    },
    labelOnPurple: {
        fontWeight: '600',
        fontSize: 15,
        color: theme.colors.surfaceElevated,
        marginBottom: 4,
    },
    hint: {
        fontSize: 13,
        color: theme.colors.textSecondary,
        marginBottom: 8,
        lineHeight: 18,
    },
    radioRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    radioItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 16,
    },
    radioLabel: {
        fontSize: 16,
        color: theme.colors.textPrimary,
    },
    radioLabelOnPurple: {
        fontSize: 16,
        color: theme.colors.surfaceElevated,
    },
    spinner: {
        marginLeft: 8,
    },
    pointerEventsNone: { pointerEvents: 'none' },
    pointerEventsAuto: { pointerEvents: 'auto' },
});
